/**
 * @module lib/data/storage
 */
export * from './Storage/PersistentStorage.js';
